export const APPROVED_DU = "1";
export const APPROVED_UW = "2";
export const CLOSED = "3";
export const CD_DISCLOSED = "4";
export const CLEARED_TO_CLOSE = "5";
export const DENIED = "6";
export const DENIED_CREDIT = "7";
export const DENIED_COMPLIANCE = "8";
export const DENIED_COST_TO_CURE = "9";
export const DENIED_QUAL_RATE = "10";
export const DENIED_RESERVES = "11";
export const DISCLOSE_LE = "12";
export const DISCLOSED_LE_NOT_SUBMITTED = "13";
export const DOCS_OUT = "14";
export const DPA_CLEARED = "15";
export const DPA_SUBMITTED = "16";
export const FUNDED = "17";
export const LOST_NOT_PROCEEDING = "18";
export const LOST_TO_COMPETION = "19";
export const NEW = "20";
export const NOTES = "21";
export const NOT_COMPLIANT = "22";
export const ON_HOLD = "23";
export const PTD_COND = "24";
export const PTF_COND = "25";
export const SUBMITTED_TO_PROCESSOR = "26";
export const TBD_REPORT = "27";
export const WORKING_NOT_SUBMITTED = "28";
export const LOST_TO_PRICING = "29";

export const LOAN_STATUS_NAMES = Object.freeze({
  [APPROVED_DU]: "Approved-DU",
  [APPROVED_UW]: "Approved-UW",
  [CLOSED]: "Closed",
  [CD_DISCLOSED]: "CD Disclosed",
  [CLEARED_TO_CLOSE]: "Cleared to Close",
  [DENIED]: "Denied",
  [DENIED_CREDIT]: "Denied Credit",
  [DENIED_COMPLIANCE]: "Denied Compliance",
  [DENIED_COST_TO_CURE]: "Denied Cost to Cure",
  [DENIED_QUAL_RATE]: "Denied Qual Rate",
  [DENIED_RESERVES]: "Denied Reserves",
  [DISCLOSE_LE]: "Disclose LE",
  [DISCLOSED_LE_NOT_SUBMITTED]: "Disclosed LE Not Submitted",
  [DOCS_OUT]: "Docs Out",
  [DPA_CLEARED]: "DPA Cleared",
  [DPA_SUBMITTED]: "DPA Submitted",
  [FUNDED]: "Funded",
  [LOST_NOT_PROCEEDING]: "Lost Not Proceeding",
  [LOST_TO_COMPETION]: "Lost to Competion",
  [LOST_TO_PRICING]: "Lost to Pricing",
  [NEW]: "New",
  [NOTES]: "NOTES",
  [NOT_COMPLIANT]: "Not Compliant",
  [ON_HOLD]: "On Hold",
  [PTD_COND]: "PTD Cond",
  [PTF_COND]: "PTF Cond",
  [SUBMITTED_TO_PROCESSOR]: "Submitted to Processor",
  [TBD_REPORT]: "TBD Report",
  [WORKING_NOT_SUBMITTED]: "Working Not Submitted"
});

// Loss reasons for a NON-selected loan scenario on the Summary Sheet. These are a
// subset of the Pipeline Status values (kept identical so the pipeline and the
// VISION win/loss report speak the same language): the Denied family, the Lost
// family (incl. Lost to Pricing), and Not Compliant. Order = pipeline grouping.
export const LOSS_REASON_STATUSES = Object.freeze([
  DENIED,
  DENIED_CREDIT,
  DENIED_COMPLIANCE,
  DENIED_COST_TO_CURE,
  DENIED_QUAL_RATE,
  DENIED_RESERVES,
  LOST_NOT_PROCEEDING,
  LOST_TO_COMPETION,
  LOST_TO_PRICING,
  NOT_COMPLIANT
]);

// { statusCode: displayName } for use directly as SelectField selectOptions.
export const LOSS_REASON_OPTIONS = Object.freeze(
  LOSS_REASON_STATUSES.reduce((options, code) => {
    options[code] = LOAN_STATUS_NAMES[code];
    return options;
  }, {})
);

// Explicit dropdown display order. Object key order can't be used because the
// codes are integer-like strings ("1".."29") which JS forces into numeric order
// (so a later-added code always sorts last). This keeps every status in its
// established position but places Lost to Pricing next to the other Lost entries.
export const LOAN_STATUS_ORDER = Object.freeze([
  APPROVED_DU,
  APPROVED_UW,
  CLOSED,
  CD_DISCLOSED,
  CLEARED_TO_CLOSE,
  DENIED,
  DENIED_CREDIT,
  DENIED_COMPLIANCE,
  DENIED_COST_TO_CURE,
  DENIED_QUAL_RATE,
  DENIED_RESERVES,
  DISCLOSE_LE,
  DISCLOSED_LE_NOT_SUBMITTED,
  DOCS_OUT,
  DPA_CLEARED,
  DPA_SUBMITTED,
  FUNDED,
  LOST_NOT_PROCEEDING,
  LOST_TO_COMPETION,
  LOST_TO_PRICING,
  NEW,
  NOTES,
  NOT_COMPLIANT,
  ON_HOLD,
  PTD_COND,
  PTF_COND,
  SUBMITTED_TO_PROCESSOR,
  TBD_REPORT,
  WORKING_NOT_SUBMITTED
]);

export const LOAN_STATUS_PERCENTS = Object.freeze({
  [APPROVED_DU]: "40",
  [APPROVED_UW]: "50",
  [CLOSED]: "100",
  [CD_DISCLOSED]: "85",
  [CLEARED_TO_CLOSE]: "70",
  [DENIED]: "0",
  [DENIED_CREDIT]: "0",
  [DENIED_COMPLIANCE]: "0",
  [DENIED_COST_TO_CURE]: "0",
  [DENIED_QUAL_RATE]: "0",
  [DENIED_RESERVES]: "0",
  [DISCLOSE_LE]: "40",
  [DISCLOSED_LE_NOT_SUBMITTED]: "40",
  [DOCS_OUT]: "75",
  [DPA_CLEARED]: "75",
  [DPA_SUBMITTED]: "70",
  [FUNDED]: "95",
  [LOST_NOT_PROCEEDING]: "0",
  [LOST_TO_COMPETION]: "0",
  [LOST_TO_PRICING]: "0",
  [NEW]: "10",
  [NOTES]: "",
  [NOT_COMPLIANT]: "0",
  [ON_HOLD]: "30",
  [PTD_COND]: "60",
  [PTF_COND]: "80",
  [SUBMITTED_TO_PROCESSOR]: "20",
  [TBD_REPORT]: "10",
  [WORKING_NOT_SUBMITTED]: "0"
});
